export default __webpack_public_path__ + "static/media/menu-girl.ca99a235.svg";